var map = {
	"./address.svg": "0e25",
	"./bibi.svg": "ea4c",
	"./douyin.svg": "44bf",
	"./mail.svg": "26f5",
	"./phone.svg": "dd82",
	"./play.svg": "fb4f",
	"./sina.svg": "b3a8",
	"./top-white.svg": "1dfe",
	"./top.svg": "deee",
	"./weixin.svg": "5afe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";